import React from 'react';

import { Route, useRouteMatch } from 'react-router-dom';

import ErrorBoundary from './ErrorBoundary';
import WhiteboardSessionsPage from './page/WhiteboardSessionsPage';
import { WhiteboardView } from './page/WhiteboardView';

const WhiteboardRoutes = () => {
    const { path } = useRouteMatch();

    return (
        <ErrorBoundary>
            <Route path={`${path}/sessions/:classUuid`} component={WhiteboardSessionsPage} />
            <Route path={`${path}/view/:sessionId`} component={WhiteboardView} />
        </ErrorBoundary>
    );
};

export default WhiteboardRoutes;
